import Table from './Table';
export default Table;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/table/index.js
// module id = 840
// module chunks = 0